export const BASIC = {
  photo: '头像',
  name: '姓名',
  sex: '性别',
  isFresh: '是否应届',
  workDate: '参加工作时间',
  currentWork: '工作单位及职务',
  address: '家庭地址',
  addressDetail: '详细地址',
  idNumber: '身份证号',
  birthday: '出生年月',
  nation: '民族',
  nativeplace: '籍贯',
  nativeLocal: '户籍所在地',
  health: '健康状况',
  maritalStatus: '婚姻状况',
  political: '政治面貌',
  joinDate: '入党日期',
  phoneNumber: '联系电话',
  email: '电子邮箱',
  profession: '专业技术资格',
  professionDate: '取得时间',
  archivesLocal: '档案所在地',
  adjustment: '是否服从调剂',
  fileUrl: '简历附件',
  remark: '其他说明备注',
};
export const DESERT = {
  rewardDate: '奖惩时间',
  rewardReason: '奖惩名称',
};
export const EDUCATION = {
  startDate: '开始时间',
  endDate: '结束时间',
  school: '毕业院校',
  major: '专业',
  type: '教育类型',
  education: '学历',
  degree: '学位',
  witness: '证明人',
  fileUrl: '上传证书附件',
};
export const HOME = {
  relationship: '称谓',
  familyMember: '姓名',
  birthday: '出生年月',
  workUnit: '现工作（学习）单位',
  position: '职务',
  political: '政治面貌',
};
export const WORK = {
  startDate: '开始时间',
  endDate: '结束时间',
  workUnit: '工作单位',
  department: '任职部门',
  position: '从事岗位与职务',
  witness: '证明人',
  witnessNumber: '证明人联系电话',
  workContent: '工作内容',
};
export const PUBLICATION = {
  pubDate: '出版时间',
  title: '论文论著名称',
  rank: '个人排名',
  institution: '刊物名/出版社',
};
export const AWARD = {
  awardDate: '获奖时间',
  title: '获奖作品名称',
  awardName: '奖项名称',
  level: '获奖等次',
  rank: '个人排名',
};
export const HONOR = {
  honorDate: '获得时间',
  title: '奖项名称',
  level: '获奖级别及排名',
  organization: '授奖部门',
};
export const ACHIEVEMENT = {
  finishTime: '完成时间',
  project: '项目（作品）',
  effect: '完成情况',
};
/*
专业技术资格profession，取得时间professionDate
教育类型type
业务获奖awardList：awardDate，title，awardName，level
论文论著publicationList：pubDate，title，rank，institution
个人荣誉honorList：honorDate，title，level，organization
*/
